import moment from "moment-timezone";
const WEEKEND_LABEL_COLOR = "#2870e2";

export function getDateTimeXAxis({ timezone }) {
  return {
    type: "datetime",
    labels: {
      formatter: function () {
        const m = moment.tz(
          this.value - moment.tz(this.value, timezone).utcOffset() * 60 * 1000,
          timezone
        );
        return getDateTimeLabel(m, this.isFirst);
      },
    },
    tickInterval: 24 * 60 * 60 * 1000, // 1 day
    crosshair: true,
  };
}

export function getDateTimeLabel(m, isFirst) {
  const d = m.format("DD");
  const wd = m.format("ddd");
  const colorStyle = [0, 6].includes(m.day())
    ? ` style="color:${WEEKEND_LABEL_COLOR};font-weight:800;"`
    : "";
  const addElement = (d) => `<span${colorStyle}>${d}</span>`;

  if (d === "01" || isFirst) {
    return `${addElement(d)} <br/> ${addElement(wd)} <br/> ${addElement(
      m.format("M")
    )}`;
  }
  return `${addElement(d)} <br/> ${addElement(wd)}`;
}

export function normalizeRevenue(revenue) {
  return revenue / 1000000;
}
